import { render } from "./FooterBar.vue?vue&type=template&id=3df78635&scoped=true"
const script = {}

import "./FooterBar.vue?vue&type=style&index=0&id=3df78635&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df78635"]])

export default __exports__